export const exclusiveRatePrefix = 'promo:';
